<div>
  <nav
    class="navbar navbar-expand-lg navbar-light py-3 position-sticky top-0 z-3"
    style="background-color: #141ed2"
  >
    <div class="container">
      <div>
        <a class="navbar-brand text-black-50" href="/#/account/login">
          <img
            loading="lazy"
            src="assets/images/Logo_LoathanhtoanMB1.png"
            alt="Logo"
            height="40"
          />
        </a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mt-2">
            <button
              class="btn bg-white text-primary btn-lg rounded-4"
              style="margin-top: -0.3rem"
            >
              <a href="tel:1900998893" class="font-weight-bolder text-primary">
                1900 99 88 93
              </a>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="service-wrapper mt-2">
    <div class="service-card register-card">
      <!-- Badge -->
      <div class="badge badge-own">Chưa đăng ký thành công</div>

      <!-- Title -->
      <h2 class="register-title">
        Đăng ký tặng Loa MB chưa thành công – Cập nhật ngay
      </h2>

      <!-- Status -->
      <div class="register-status warning-status">
        Bạn <b>chưa đăng ký thành công</b> do chưa đáp ứng điều kiện tham gia chương trình.
      </div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Section: Lý do -->
      <div class="benefits-title">MB đã kiểm tra hồ sơ đăng ký nhận Loa Thanh Toán MB của bạn và nhận thấy:</div>
      <ul class="benefits">
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Đăng ký chưa chính chủ tài khoản Hộ Kinh Doanh (HKD)</div>
        </li>
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Hoặc chưa đáp ứng điều kiện của chương trình</div>
        </li>
      </ul>
      <div class="register-note-arrow">→ Đây là tình trạng khá phổ biến khi nhiều khách hàng đăng ký chưa đúng loại tài khoản</div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Section: Điều kiện -->
      <div class="benefits-title">Chương trình áp dụng cho ai?</div>
      <ul class="benefits">
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Có tài khoản HKD tại MB</div>
        </li>
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Có hoạt động kinh doanh thực tế</div>
        </li>
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Đáp ứng điều kiện xét duyệt theo chương trình</div>
        </li>
      </ul>
      <div class="register-note-arrow">→ Việc kiểm tra này giúp đảm bảo ưu đãi được trao đúng đối tượng</div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Section: Cách tiếp tục -->
      <div class="benefits-title">Cách để tiếp tục nhận loa miễn phí</div>
      <p class="benefits-sub">Đừng lo! Bạn vẫn có thể quay lại chương trình rất dễ dàng. Chỉ cần hai bước:</p>
      <ul class="benefits">
        <li class="benefit-item">
          <span class="tick step-tick">1</span>
          <div class="benefit-text"><b>Bước 1:</b> Mở / chuyển đổi sang tài khoản HKD tại MB</div>
        </li>
        <li class="benefit-item">
          <span class="tick step-tick">2</span>
          <div class="benefit-text"><b>Bước 2:</b> Hoàn tất điều kiện theo yêu cầu</div>
        </li>
      </ul>
      <div class="register-note-arrow">→ Sau đó, hồ sơ của bạn sẽ được xét duyệt lại để nhận ưu đãi tặng loa</div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Section: Cần loa ngay -->
      <div class="benefits-title">Cần sử dụng loa ngay?</div>
      <p class="benefits-sub">Nếu bạn đang cần triển khai bán hàng ngay, bạn có thể đăng ký mua Loa Thanh Toán MB:</p>
      <ul class="benefits">
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Kích hoạt nhanh – sử dụng ngay</div>
        </li>
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Không cần chờ xét duyệt</div>
        </li>
        <li class="benefit-item">
          <span class="tick">✔</span>
          <div class="benefit-text">Vẫn đầy đủ tính năng hỗ trợ bán hàng</div>
        </li>
      </ul>

      <!-- Highlight note -->
      <div class="register-highlight">
        Đừng bỏ lỡ ưu đãi từ MB 
        <ul class="benefits">
          <li class="benefit-item">
            <div class="benefit-text">Chỉ cần cập nhật đúng điều kiện, bạn vẫn có cơ hội nhận loa miễn phí từ chương trình.</div>
          </li>
          <li class="benefit-item">
            <div class="benefit-text">Chương trình diễn ra đến khi có thông báo mới</div>
          </li>
        </ul>
      </div>

      <!-- Buttons -->
      <div class="d-flex gap-2 mt-3">
        <button class="btn secondary-btn flex-fill" (click)="toBuyLoa()">
          Mua loa
        </button>
        <button class="btn primary-btn flex-fill" (click)="toGiftRegister()">
          Đăng ký tặng loa
        </button>
      </div>

      <!-- Note -->
      <div class="note">* Chỉ mất vài phút để hoàn tất đăng ký.</div>
    </div>
  </div>
</div>
